@if (!!groupsCount) {
  <div id="groups-selected" [attr.data-test]="'selected-groups'">
    <strong>{{ 'Selected Groups' | translate: locale.language }}:</strong>
    <div style="padding: 1rem; margin-bottom: 1rem">
      <app-loading [hasLoaded]="!groupsLoading" [isCircle]="false"></app-loading>
      <div *ngIf="!groupsLoading" [attr.data-test]="'selected-group-items'" class="chip-button-container">
        <ng-container *ngIf="!!groupsResolved?.length; else empty">
          <button
            *ngFor="let item of groupsResolved"
            [ngClass]="item.isMissing ? 'chip-button-missing' : 'chip-button'"
            mat-stroked-button
            color="primary"
            (click)="onGroupClick(item)"
            [attr.data-test]="'group'"
            [attr.data-testid]="item.name"
            [matTooltip]="'Alert.Recipients.UnknownGroupTooltip' | translate:locale.language"
            [matTooltipDisabled]="!item.isMissing"
          >
            {{ item.name }} <mat-icon iconPositionEnd>open_in_new</mat-icon>
          </button>
        </ng-container>
        <ng-template #empty>
          <mat-chip class="empty" disabled="true">{{ 'None Found' | translate: locale.language }}</mat-chip>
        </ng-template>
      </div>
    </div>
  </div>
}

@if (!!usersCount) {
  <div id="users-selected" [attr.data-test]="'selected-contacts'">
    <strong>{{ 'Selected Contacts' | translate: locale.language }}:</strong>
    <div style="padding: 1rem; margin-bottom: 1rem">
      <app-loading [hasLoaded]="!usersLoading" [isCircle]="false"></app-loading>
      <div *ngIf="!usersLoading || !!usersResolved().length" [attr.data-test]="'selected-contact-items'" class="chip-button-container">
        <ng-container *ngIf="!!usersResolved().length; else empty">
          <button
            *ngFor="let item of usersResolved()"
            [ngClass]="item.isMissing ? 'chip-button-missing' : 'chip-button'"
            mat-stroked-button
            color="primary"
            (click)="onUserClick(item)"
            [attr.data-test]="'user'"
            [attr.data-testid]="item.displayName"
            [matTooltip]="'Alert.Recipients.UnknownUserTooltip' | translate:locale.language"
            [matTooltipDisabled]="!item.isMissing"
          >
            {{ item.displayName }} <mat-icon iconPositionEnd>open_in_new</mat-icon>
          </button>
        </ng-container>
        <ng-template #empty>
          <mat-chip class="empty" disabled="true">{{ 'None Found' | translate: locale.language }}</mat-chip>
        </ng-template>
      </div>
      <button *ngIf="usersHasMore" mat-button color="primary" (click)="onUsersLoadMore()" style="margin: 1rem">
        {{ 'Load More…' | translate: locale.language }}
      </button>
    </div>
  </div>
}

@if (!!citiesCount) {
  <div id="cities-selected" [attr.data-test]="'selected-cities'">
    <strong>{{ 'Selected Cities' | translate: locale.language }}:</strong>
    <div style="padding: 1rem">
      <app-recipient-details-cities [alert]="alert"></app-recipient-details-cities>
    </div>
  </div>
}

@if (!!geoFencesCount) {
  <div id="geofences-selected">
    <strong>{{ 'Selected Map Areas' | translate: locale.language }}:</strong>
    <div style="padding: 0 1rem">
      <app-recipient-details-areas [alert]="alert"></app-recipient-details-areas>
    </div>
  </div>
}

@if (hasDistSources) {
  <div id="adhoc-selected">
    <strong>{{ 'Ad Hoc Sources' | translate: locale.language }}:</strong>
    <div style="padding: 1rem">
      <app-recipient-details-adhoc [alert]="alert" [distributionList]="distributionList"></app-recipient-details-adhoc>
    </div>
  </div>
}

@if (!!searchesCount) {
  <div id="searches-selected" class="selected-searches" [attr.data-test]="'selected-searches'">
    <div class="selected-searches-header">
      <strong>{{ 'Selected Searches' | translate: locale.language }}</strong>
    </div>
    <div class="selected-searches-content">
      @for (search of searches; track search.id) {
        <div class="search-item">
          <div class="search-label">
            <small>Search ({{search.filter.conditions.length}} {{ search.filter.conditions.length === 1 ? 'Condition' : 'Conditions' }})</small>
          </div>
          <div class="chip-button-container" [attr.data-test]="'selected-searches-items'">
            @for (condition of search.filter.conditions; track condition.field) {
              <button
                class="chip-button search-chip"
                mat-stroked-button
                color="primary"
                [attr.data-test]="'search'"
                [attr.data-testid]="condition.field"
                (click)="onFilterClick(condition, searchFields?.[condition.field])"
              >
                {{ searchFields?.[condition.field] ?? condition.field }}: {{ condition.values | maxItems: 3 }}
              </button>
            }
          </div>
        </div>
      } @empty {
        <div class="empty-state">
          <mat-chip class="empty" disabled="true">{{ 'None Found' | translate: locale.language }}</mat-chip>
        </div>
      }
    </div>
  </div>
}